export default function updateSignup() {
  const useTitle = true;
  const useDescription = false;
  const signupTitle = 'Subscribe Now';
  const signupTdescription = 'Don’t be left behind! Sign up today for the latest fair updates!';
  const inputPlaceholder = 'Email Address';
  const buttonLabel = 'Sign Up';

  const $signupElement = $('.signup-section .emailSignup');
  const $signupText = $signupElement.find('.emailSignupText');

  $signupText.replaceWith(`
      <div class="signup-text">
        ${useTitle ? `<h3 class="signup-title">${signupTitle}</h3>` : ''}
        ${useDescription ? `<p class="signup-description">${signupTdescription}</p>` : ''}
      </div>
    `);

  $signupElement
    .find('.emailInputField, .emailInputSubmit')
    .wrapAll('<div class="input-container"></div>');
  $signupElement.find('.emailInputField input').val('').attr('placeholder', inputPlaceholder);
  $signupElement.find('.emailInputSubmit a').text(buttonLabel);
}
